export default "__VITE_ASSET__D_HEo0So__"